<template>
	<div id="usage-entry">
		<div class="vx-row w-full">
			<div class="vx-col w-full">
				<vx-card class="mb-base w-full" title="Setting BHP">
					<div class="vx-row">
						<div class="vx-col w-full mt-2 mb-2 flex">
							<vs-input v-model="nama" label="Nama" class="w-1/4"/>
							<vs-select
								autocomplete
								:disabled="disable"
								class="w-1/4 ml-10"
								name="labSection"
								label="Bagian Lab"
								v-model="labSection"
							>
								<vs-select-item
									:key="index"
									:value="item.id"
									:text="item.name"
									v-for="(item,index) in listLabSection"
								/>
							</vs-select>
							<label for class="ml-10 mt-8 vs-input--label"><b>Default</b></label>
							<vs-switch v-model="def" class="ml-10 mt-8"/>
							<vs-button class="mr-4 mb-4 mt-4 ml-20" icon-pack="feather" @click="onConfirm">Simpan</vs-button>
							<vs-button
								class="mr-4 mb-4 mt-4"
								color="danger"
								@click="$router.push('/stock/purchase').catch(() => {})"
							>Batal</vs-button>
						</div>
					</div>
				</vx-card>
			</div>
		</div>
		<div class="vx-row w-full">
			<div class="vx-col w-full">
				<vx-card class="mb-base w-full" title="BHP Tipe Pasien">
					<template slot="actions">
						<vs-button class="ml-10" @click="activePromptProduct = true; activePromptButton = 1" color="primary">Tambah Produk</vs-button>
					</template>
					<div class="vx-row">
						<div class="vx-col w-full mt-2 mb-2">
							<vs-table stripe :data="listProdukPasien">
								<template slot="thead">
									<vs-th>Nama Produk</vs-th>
									<vs-th>Qty</vs-th>
									<vs-th>#</vs-th>
								</template>
								<template slot-scope="{data}">
									<vs-tr :key="indextr" v-for="(tr, indextr) in data">
										<vs-td>{{data[indextr].product.name}}</vs-td>
										<vs-td>{{data[indextr].qty}}</vs-td>
										<vs-td vs-align="center">
											<vs-button @click="delRowProdukPasien(indextr)" color="danger">Hapus</vs-button>
										</vs-td>
									</vs-tr>
								</template>
							</vs-table>
						</div>
					</div>
				</vx-card>
			</div>
		</div>
		<div class="vx-row w-full">
			<div class="vx-col w-full">
				<vx-card class="mb-base w-full" title="BHP Tipe Group Test">
					<template slot="actions">
						<vs-button class="ml-10" @click="activePromptProduct = true; activePromptButton = 2" color="warning">Tambah Produk</vs-button>
					</template>
					<div class="vx-row">
						<div class="vx-col w-full mt-2 mb-2">
							<vs-table stripe :data="listProdukGroupTest">
								<template slot="thead">
									<vs-th>Group Test</vs-th>
									<vs-th>Nama Produk</vs-th>
									<vs-th>Qty</vs-th>
									<vs-th>#</vs-th>
								</template>
								<template slot-scope="{data}">
									<vs-tr :key="indextr" v-for="(tr, indextr) in data">
										<vs-td>{{data[indextr].groupTest.name}}</vs-td>
										<vs-td>{{data[indextr].product.name}}</vs-td>
										<vs-td>{{data[indextr].qty}}</vs-td>
										<vs-td vs-align="center">
											<vs-button @click="delRowProdukGroupTest(indextr)" color="danger">Hapus</vs-button>
										</vs-td>
									</vs-tr>
								</template>
							</vs-table>
						</div>
					</div>
				</vx-card>
			</div>
		</div>
		<div class="vx-row w-full">
			<div class="vx-col w-full">
				<vx-card class="mb-base w-full" title="BHP Tipe Pemeriksaan (Measure)">
					<template slot="actions">
						<vs-button class="ml-10" @click="activePromptProduct = true; activePromptButton = 3" color="#2196f3">Tambah Produk</vs-button>
					</template>
					<div class="vx-row">
						<div class="vx-col w-full mt-2 mb-2">
							<vs-table stripe :data="listProdukMeasure">
								<template slot="thead">
									<vs-th>Nama Pemeriksaan</vs-th>
									<vs-th>Nama Produk</vs-th>
									<vs-th>Qty</vs-th>
									<vs-th>#</vs-th>
								</template>
								<template slot-scope="{data}">
									<vs-tr :key="indextr" v-for="(tr, indextr) in data">
										<vs-td>{{data[indextr].measure.name}}</vs-td>
										<vs-td>{{data[indextr].product.name}}</vs-td>
										<vs-td>{{data[indextr].qty}}</vs-td>
										<vs-td vs-align="center">
											<vs-button @click="delRowProduMeasure(indextr)" color="danger">Hapus</vs-button>
										</vs-td>
									</vs-tr>
								</template>
							</vs-table>
						</div>
					</div>
				</vx-card>
			</div>
		</div>
		<div class="vx-col w-full">
			<div class="flex flex-end items-start mb-4">

			</div>
		</div>

		<vs-prompt
			title="Form Tambah Produk"
			@accept="acceptProduct"
			accept-text="Tambah"
			cancel-text="Batal"
			:active.sync="activePromptProduct"
		>
			<div class="con-exemple-prompt">
				<div class="vx-col w-full mt-2 mb-2" v-if="activePromptButton==2">
					<vs-select
						autocomplete
						class="w-full"
						name="groupTest"
						label="Group Test"
						v-model="groupTest"
					>
						<vs-select-item
							:key="index"
							:value="item.id"
							:text="item.name"
							v-for="(item,index) in listGroupTest"
						/>
					</vs-select>
				</div>
				<div class="vx-col w-full mt-2 mb-2" v-if="activePromptButton==3">
					<vs-select
						autocomplete
						class="w-full"
						name="measure"
						label="Pemeriksaan (Measure)"
						v-model="measure"
						@input-change="searchMeasure"
					>
						<vs-select-item
							:key="index"
							:value="item.id"
							:text="item.name"
							v-for="(item,index) in listMeasure"
						/>
					</vs-select>
				</div>
				<div class="vx-col w-full mt-2 mb-2">
					<vs-select
						autocomplete
						class="w-full"
						name="product"
						label="Nama Produk"
						v-model="product"
					>
						<vs-select-item
							:key="index"
							:value="item.id"
							:text="item.name"
							v-for="(item,index) in listProduct"
						/>
					</vs-select>
				</div>
				<div class="vx-col w-full mt-2 mb-2">
					<vs-input class="w-full" v-model="qty" label="Qty" />
				</div>
			</div>
		</vs-prompt>
	</div>
</template>

<script>
import ref from "@/api/ref.js";
import formsearch from "@/api/form-search.js";
import stock from "@/api/stock.js";
import tool from "@/tool/form_tool.js";
import master from "@/api/master.js";
import lab from "@/api/lab.js";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
	components: {
		Datepicker,
	},
	data() {
		return {
			id: this.$route.params.id,
			isEdit: (!this.$route.params.type? true:(this.$route.params.type=='update'?true:false)),
			disable: false,
			activePromptProduct: false,
			activePromptButton: 1,
			startDate: "",
			description: "",
			product: "",
			groupTest: "",
			measure: "",
			listProdukPasien: [],
			listProdukGroupTest: [],
			listProdukMeasure: [],
			listProduct: [],
			listGroupTest: [],
			listMeasure: [],
			listLabSection: [],
			qty: "",
			product: "",

			labSection: "",
			nama: "",
			def: false
		};
	},
	methods: {
		onConfirm() {
			this.$vs.dialog({
				type: "confirm",
				color: "warning",
				title: `Konfirmasi`,
				text: "Simpan data ?",
				acceptText: "Ya",
				cancelText: "Tidak",
				accept: this.submitData,
			});
		},
		submitData() {
		console.log('def :'+this.def);
			const data = {
				name: this.nama,
				labSection: {id: this.labSection},
				def: (this.def?1:0)
			};

			data.patient = this.listProdukPasien;
			data.groupTest = this.listProdukGroupTest;
			data.test = this.listProdukMeasure;

			if (this.id) {
				data.id = this.id;
			}

			let config = {
				headers: {
					"content-type": "application/json",
				},
			};

			stock.saveUsage(data, config)
				.then((res) => {
					if (res.data.status) {
						this.$vs.notify({
							title: "Info",
							time: 3000,
							text:
								"Data telah berhasil di submit",
							color: "success",
							position: "top-right",
						});
						this.$router.push("/stock/usage");
					} else {
						this.$vs.notify({
							title:
								"Terjadi Kesalahan",
							time: 3000,
							text: res.data.message,
							color: "danger",
							position: "top-right",
						});
					}
				})
				.catch((error) => {
					if (error.response) {
						this.$vs.notify({
							title:
								"An Error Occured",
							time: 3000,
							text:
								error.response
									.data
									.message,
							color: "danger",
							position: "top-right",
						});
					}
				});
		},
		acceptProduct() {
			const pd = this.product;
			const gt = this.groupTest;
			const m = this.measure;
			const pq = this.qty;
			this.product = "";
			this.groupTest = "";
			this.measure = "";
			this.qty = "";
			var xpd = "";

			this.listProduct.forEach(function (e) {
				if (e.id == pd) {
					xpd = e;
				}
			});

			let obj = {product: {id: xpd.id, name: xpd.name}, qty: pq};
			if (this.activePromptButton == 1) {
				this.listProdukPasien.push(obj);
			} else if (this.activePromptButton == 2) {
				var xgt = "";

				this.listGroupTest.forEach(function (e) {
					if (e.id == gt) {
						xgt = e;
					}
				});
				obj.groupTest= {id: xgt.id, name: xgt.name};

				this.listProdukGroupTest.push(obj);
			} else if (this.activePromptButton == 3) {
				var xm = "";

				this.listMeasure.forEach(function (e) {
					if (e.id == m) {
						xm = e;
					}
				});
				obj.measure= {id: xm.id, name: xm.name};

				this.listProdukMeasure.push(obj);
			}
		},
		delRowProdukPasien(idx) {
			this.listProdukPasien.splice(idx, 1);
		},
		delRowProdukGroupTest(idx) {
			this.listProdukGroupTest.splice(idx, 1);
		},
		delRowProdukMeasure(idx) {
			this.listProdukMeasure.splice(idx, 1);
		},
		async getListProduct() {
			const x = await master.listProduk();
			this.listProduct = x.data.data;
		},
    async getLabSection() {
      const x = await lab.listBagianLab();
			this.listLabSection = x.data.data;
    },
		async getListGroupTest() {
			const x = await lab.listGroupTest();
			this.listGroupTest = x.data.data;
		},
		async getListMeasure() {
			const x = await lab.listMeasure();
			this.listMeasure = x.data.data;
		},
		async searchMeasure(event) {
      if (event.target.value.length > 2) {
          const frms = await lab.listMeasure({keyword: event.target.value});
          this.listMeasure = frms.data.data;
      }
    },
	},
	mounted() {},
	created() {
		this.getListProduct();
		this.getLabSection();
		this.getListGroupTest();
		this.getListMeasure();
	},
};
</script>

<style lang="scss" scoped>
.bordered {
	border-width: 1px;
	border-radius: 4px;
	box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
	margin: 0;
}
.vx-custom-remove-icon {
	text-align: right;
}
.vs-textarea-primary.focusx {
	border: 1px solid #0056a8 !important;
	box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
}
.vs-checkbox-default {
	transform: translate(0, -70%);
	top: 70%;
}
</style>
